import { render, staticRenderFns } from "./SettingHpp.vue?vue&type=template&id=24688b9a"
import script from "./SettingHpp.vue?vue&type=script&lang=js"
export * from "./SettingHpp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports